import React, { memo } from 'react';

interface DetailPageFormRowProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * 表单行：固定 120px 左对齐标签 + 自适应内容区（控件统一右对齐）。
 * 标签作为行标题，字号略大于控件文字以建立视觉层级。
 */
const DetailPageFormRowInner: React.FC<DetailPageFormRowProps> = ({
  label,
  children,
  className = '',
}) => {
  return (
    <div className={`grid grid-cols-[120px_1fr] items-center gap-x-6 ${className}`}>
      <span className="text-[24px] text-white/45 shrink-0">{label}</span>
      <div className="flex justify-end min-w-0">{children}</div>
    </div>
  );
};

export const DetailPageFormRow = memo(DetailPageFormRowInner);
